import type { PropsWithChildren, ComponentProps, JSX } from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { fontFamilies, mesaColorNames } from '@/src/common/theme'

interface SquareOverviewProps
  extends PropsWithChildren,
    Pick<ComponentProps<typeof View>, 'style'> {
  header?: JSX.Element
  items: { name: string; value: string }[]
}

export function SquareOverview(props: SquareOverviewProps) {
  const { items } = props
  return (
    <View style={[styles.cardContainer, props.style]}>
      {props.header}
      <View style={styles.cardContainerItems}>
        {items.map(({ name, value }, index) => (
          <View
            key={`square-overview-${index}`}
            style={[
              styles.squareOverviewItem,
              index > 0 ? styles.squareOverviewNonFirstItem : undefined,
            ]}
          >
            <Text>{name}</Text>
            <Text style={styles.value}>{value}</Text>
          </View>
        ))}
      </View>
      {props.children}
    </View>
  )
}

const styles = StyleSheet.create({
  cardContainerItems: {
    rowGap: 25,
  },
  cardContainer: {
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    padding: 20,
    margin: 5,
    borderRadius: 10,
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.17,
    shadowRadius: 3.05,
    elevation: 4,
  },
  value: {
    fontFamily: fontFamilies['PlusJakartaSans-Bold'],
    fontWeight: 700,
  },
  squareOverviewItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  squareOverviewNonFirstItem: {
    paddingTop: 25,
    borderTopWidth: 1,
    borderTopColor: mesaColorNames['Black/5% rgba(28, 28, 28, 0.05)'],
  },
})
